<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <GoBack />
            <h3 class="d-inline heading">{{ tasklist_name }}</h3>
          </div>
          <div class="heading-seperator"></div>

          <div style="clear: both" class="margin-bottom-10"></div>
          <div class="col-md-12 counter_subtask-list" id="tasks">
            <div v-for = "(subtask, stindex) in subtasks">
              <div class="subtask-wrapper">
                <h4 class="panel-title">
                  <b-link v-b-toggle="'collapse-' + subtask.id">
                    <span class="counter_subtask-list__counter"></span>
                    {{ subtask.name }}
                  </b-link>
                </h4>
                <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2 subtask-wrapper">
                  <b-card>
                    <div class="col-md-12 override-padding counter_heading-list">
                      <div v-for = "(heading, index) in subtask.headings">
                        <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id" size="sm" class="sub-heading">
                          <span class="counter_heading-list__counter"></span>
                          {{ heading.name }}
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </b-link>
                        <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper">
                          <div class="col-md-12 override-padding counter_task-list">
                            <div v-for = "task in heading.tasks">
                              <b-card @click="openHistoryModal('' + account_id + '', '' + task.id + '')" class="float-left d-none d-md-block d-lg-block modal-task">
                                <div class="task-title">
                                  <span class="counter_task-list__counter"></span>
                                  {{ task.description }}
                                </div>
                                <div class="task-score" data-toggle="tooltip" title="Score" v-if="task.score">
                                  {{ task.score }}
                                </div>
                              </b-card>

                              <b-card v-bind:id="task.id" class="float-left  d-block d-sm-block d-md-none">
                                <div class="task-title">
                                  <span class="counter_task-list__counter"></span>
                                  {{ task.description }}
                                </div>
                                <div class="task-score" v-if="task.score">
                                  {{ task.score }}
                                </div>
                                <div class="comment-icon-wrapper" v-if="task.score">
                                  <router-link v-bind:to="'/student/task-assessment-view/' + account_id + '/' + task.id + '/' + tasklist_id + '@' + heading.id + '@' + subtask.id + ''">
                                    <i class="fa fa-comment"></i><span class="view-comment">Comments</span>
                                  </router-link>
                                </div>
                              </b-card>
                            </div>
                          </div>
                          <div style="clear: both;"></div>
                        </b-collapse>
                      </div>
                    </div>
                    <div class="col-md-12 override-padding counter_task-list">
                      <div v-for = "substasklisttask in subtask.tasks" class="task-wrapper">
                        <b-card @click="openHistoryModal('' + account_id + '', '' + substasklisttask.id + '')" class="float-left d-none d-md-block modal-task">
                          <div class="task-title">
                            <span class="counter_task-list__counter"></span>
                            {{ substasklisttask.description }}
                          </div>
                          <div class="task-score" data-toggle="tooltip" title="Score" v-if="substasklisttask.score">
                            {{ substasklisttask.score }}
                          </div>
                        </b-card>

                        <b-card v-bind:id="substasklisttask.id" class="float-left d-block d-sm-block d-md-none">
                          <div class="task-title">
                            <span class="counter_task-list__counter"></span>
                            {{ substasklisttask.description }}
                          </div>
                          <div class="task-score" v-if="substasklisttask.score">
                            {{ substasklisttask.score }}
                          </div>
                          <div class="comment-icon-wrapper" v-if="substasklisttask.score">
                            <router-link v-bind:to="'/student/task-assessment-view/' + account_id + '/' + substasklisttask.id + '/' + tasklist_id + '@' + 'null' + '@' + subtask.id + ''">
                              <i class="fa fa-comment"></i><span class="view-comment">Comments</span>
                            </router-link>
                          </div>
                        </b-card>

                      </div>
                    </div>
                    <div style="clear: both;"></div>
                  </b-card>
                </b-collapse>
              </div>
            </div>


            <custommodal :isModalVisible="isModalVisible" @close="isModalVisible = false">
                <div slot="header" class="sub-heading">{{history_title}}</div>
                <div slot="body">
                  <div class="history-table-wrapper">
                  <table class="generic-list">
                    <thead>
                    <tr>
                        <th class="date">DATE</th>
                        <th class="score">SCORE</th>
                        <th class="comment">COMMENT</th>
                        <th class="postedby">COMMENTED BY</th>
                    </tr>
                    </thead>
                    <div v-show="assessment_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                    <template v-for = "history in history_comment">
                     <tr>
                     <td>{{history.createdAt | formatDate}}</td>
                     <td>{{history.score}}</td>
                      <td>{{history.comment}}</td>
                      <td>{{history.mentor_name}}</td>
                      </tr>
                   </template>
                   <template v-if="history_comment.length == 0 && assessment_loading == false">
                     <tr >
                       <td colspan="4">No Assessments Found.</td>
                     </tr>
                  </template>
                 </table>
               </div>
               </div>
           </custommodal>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import custommodal from '../manager/custom_modal.vue';
import axios from 'axios';
import moment from 'moment';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
        data() {
          return {
            'subtasks': [],
            'tasklist_id': '',
            'tasklist_name': '',
            'isModalVisible': false,
            'history_title': '',
            'history_comment': '',
            'loading': false,
            'score_selected': 1,
            'comments': '',
            'open': true,
            'close': false,
            'page_loading': false,
            'account_id': '',
            'assessment_loading': false,
            }
        },
        components: {
          UserMenu,
          GoBack,
          custommodal
        },
        methods: {
          closeModal() {
            this.isModalVisible = false;
            this.$emit('close');
          },
          showTasks(account_id, tasklist_id) {
             axios.get('/mentee/account/tasklist_details/' + account_id + '/' + tasklist_id, {

             })
             .then(response =>  {
                this.page_loading = false;
                this.subtasks = response.data.subtasks;
                this.tasklist_name = response.data.title;
             })
             .catch(function(error) {
                 console.log(error);
             });
           },
           openHistoryModal(accountId, taskId) {
             this.comments = '';
             this.score_selected = 1;
             this.isModalVisible = true;
             this.loading = true;
             this.history_title = '';
             this.history_comment = '';
             this.assessment_loading = true;
             axios.get('/mentee/assessment/view', {
               params: {
                 account_id: accountId,
                 task_id: taskId,
                 tasklist_id: this.tasklist_id,
               }
             })
             .then(response =>  {
                this.loading = false;
                this.assessment_loading = false;
                this.history_title = response.data.task.description;
                this.history_comment = response.data.history;
             })
             .catch(function(error) {
                console.log(error);
             });
           },
        },
        created: function () {
          this.page_loading = true;
          this.tasklist_id = this.$route.params.tasklist_id;
          this.account_id = this.$route.params.account_id;
          this.showTasks(this.account_id, this.tasklist_id);
        },
        updated() {
          setTimeout(()=>{
            var e1_val = this.$route.query.e1;
            var e2_val = this.$route.query.e2;
            var e3_val = this.$route.query.e3;
            if(e1_val) {

                var ele2 = document.getElementById("collapse-" + e1_val).parentElement.getElementsByClassName("panel-title")[0].getElementsByTagName("a")[0];
                ele2.className = '';
                document.getElementById("collapse-" + e1_val).parentElement.getElementsByClassName("panel-title")[0].getElementsByTagName("a")[0].setAttribute("aria-expanded", true);
                document.getElementById("collapse-" + e1_val).style.display = "block";
                if(e2_val > 0) {
                  var ele1 = document.getElementById("collapse-" + e1_val + "-" + e2_val);
                  ele1.style.display = 'block';
                }
                document.getElementById(e3_val).scrollIntoView(false);
            }
          }, 500);
        },
    }



</script>

<style scoped>

  .back-btn-wrapper {
    width:100%;
    margin-left: 10px;
    margin-right: 0px;
  }
  hr {
    margin: 10px 0px;
  }
  .task-item-list {
    margin-top: 5px;
  }
  #tasks {
      margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/student_account_tasklist_details.vue